import { render, staticRenderFns } from "./MalSwiper.vue?vue&type=template&id=f58f2806&scoped=true&"
import script from "./MalSwiper.vue?vue&type=script&lang=js&"
export * from "./MalSwiper.vue?vue&type=script&lang=js&"
import style0 from "./MalSwiper.vue?vue&type=style&index=0&id=f58f2806&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58f2806",
  null
  
)

export default component.exports